"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var SidebarMenuContext_1 = require("../Components/Sidebar/SidebarMenuContext");
function JetApplicationLogo(_a) {
    var className = _a.className;
    var sidebarOpen = (0, react_2.useContext)(SidebarMenuContext_1.SidebarContext);
    return (react_1.default.createElement("img", { src: sidebarOpen ? "/images/qplayhorizontal.svg" : "/images/qplay.svg", className: className }));
}
exports.default = JetApplicationLogo;
